import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Input } from "@progress/kendo-react-inputs";
import { consulationService } from '../../services/api/consultation.service';
import { nomService } from '../../services/api/nom.service';
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";
import { ListDialog } from "../shared/listDialog";

export const ConsultationDiagnostics = (props) => {

    const [diagnosticList, setDiagnosticList] = useState([]);
    const [defaults, setDefaults] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [newDiagnostic, setNewDiagnostic] = useState({
        idDiagnostic: "",
        comentariu: "",
        idConsultatie: props.consultatie ?? 0
    });

    const [searchTerm, setSearchTerm] = useState("");
    const [virtual, setVirtual] = useState({
        skip: 0,
        take: 10,
        pageSize: 10,
        total: 0
    });

    // Aduc dropdownul cu diagnostice in alt useEffect
    // pentru ca atunci cand nu am consultatie nu se mai tragea lista de diagnostice
    useEffect(() => {
        nomService.getDiagnostics()
            .then(response => {
                if (response) {
                    setDropdown(response);
                    // modifi totalul de pe virtual
                    setVirtual((prevState) => ({
                        ...prevState,
                        total: response.length
                    }));
                }
            });
    }, []);

    // Aduc  lista de diagnostice
    useEffect(() => {
        if (props && props.consultatie) {
            consulationService.getDiagnostics({ consultation: props.consultatie })
                .then(response => {
                    if (response) {
                        setDiagnosticList(response);
                        props.setDiagnostice(response);
                    }
                });
        }
    }, [props.render]);

    // Dupa ce le aduc , setez defaulturile
    useEffect(() => {
        if (diagnosticList.length == 0) {
            setDefaults([]);
            return;
        }
        if (diagnosticList.length > 0 && dropdown.length > 0) {
            var d = [];
            for (var item in diagnosticList) {
                var el = utils.findObjectById(dropdown, diagnosticList[item].idDiagnostic)
                if (el) {
                    d.push(el);
                }
                else {
                    // Pentru diagnoticele care nu sunt active le aduc din baza si le adaug in dropdown
                    if (diagnosticList[item].idDiagnostic > 0) {
                        nomService.getDiagnosticsById({ id : diagnosticList[item].idDiagnostic })
                            .then(response => {
                                if (response) {
                                    var diag = [...dropdown];
                                    diag.push(response[0]);
                                    setDropdown(diag);
                                }
                            });
                    }
                }
            }

            

            setDefaults(d);
        }

    }, [diagnosticList, dropdown]);

    const handleAddDiagnostic = () => {
        const updatedDiagnosticList = [...diagnosticList, newDiagnostic];
        setDiagnosticList(updatedDiagnosticList);
        props.setDiagnostice(updatedDiagnosticList);
        setNewDiagnostic({ id_diagnostic: "", comentariu: "" });
        props.setIsModified(true);
    };

    const handleDiagnosticChange = (event, index, field) => {
        const updatedDiagnosticList = [...diagnosticList];
        var v = event.target.value;
        if (v.hasOwnProperty("id")) {
            updatedDiagnosticList[index][field] = v.id;
        }
        else {
            updatedDiagnosticList[index][field] = v;
        }

        setDiagnosticList(updatedDiagnosticList);
        props.setDiagnostice(updatedDiagnosticList);
        props.setIsModified(true);

        setSearchTerm("");
    };

    const handleDeleteDiagnostic = (index) => {


        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta investigatie?"
            , () => {
                const updatedDiagnosticList = [...diagnosticList];
                updatedDiagnosticList.splice(index, 1);

                setDiagnosticList(updatedDiagnosticList);
                props.setDiagnostice(updatedDiagnosticList);
                props.setIsModified(true);
            }
            , () => { return; }
        );
       
    };


    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {

        let newList = [...diagnosticList];
        newList[clickedIndex].idDiagnostic = dropdown[item].id;
        setDiagnosticList(newList);
        props.setDiagnostice(newList);

    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
        setVirtual((prevState) => ({
            ...prevState,
            skip: 0
        }));

        
    };

    const filteredDiagnostics = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;

    return (

        <>
            <fieldset className="mt10 pb20">
                <legend className="pb5">Diagnostice <span className="red">*</span></legend>
                <table className="tbl tbladd mt5" data-name="lista_diagnostice" width="100%">
                    <thead>
                        <tr>
                            <th>Diagnostic</th>
                            <th>Comentariu</th>
                            <th width="50">Editeaza</th>
                            <th width="50">Sterge</th>
                        </tr>
                    </thead>
                    <tbody>
                        {diagnosticList.map((diagnostic, index) => (
                            <tr key={index}>
                                <td>
                                    <DropDownList
                                        data={filteredDiagnostics}
                                        virtual={virtual}
                                        onVirtualPageChange={(e) => {
                                            setVirtual({
                                                skip: e.page.skip,
                                                take: e.page.take
                                            });
                                        }}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        name="idDiagnostic"
                                        data-label="diagnostic"
                                        className="text w550 fl"
                                        onChange={(event) =>
                                            handleDiagnosticChange(event, index, "idDiagnostic")
                                        }
                                        disabled={props.statusFinalizare == 1}
                                        filterable
                                        onFilterChange={handleFilterChange}
                                    />
                                </td>
                                <td>
                                    <Input
                                        data-name="comentariu"
                                        data-label="diagnostic"
                                        value={diagnostic.comentariu ?? ""}
                                        onChange={(event) =>
                                            handleDiagnosticChange(event, index, "comentariu")
                                        }
                                        disabled={props.statusFinalizare == 1}
                                    />
                                </td>
                                {props.statusFinalizare != 1 &&
                                    <>
                                        <td className="center" data-name="diagnostic_edit" onClick={() => handleClick(index)}>
                                            <span className="icon modifica center"></span>
                                        </td>
                                        <td className="center" data-name="diagnostic_del" onClick={() => handleDeleteDiagnostic(index)}>
                                            <span className="icon sterge center"></span>
                                        </td>
                                    </>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>
                {
                    props.statusFinalizare != 1 &&
                    <button
                        data-name="adauga_diagnostic"
                        className="btn mt10"
                        className="btn mt10"
                        onClick={handleAddDiagnostic}
                    >
                        Adauga diagnostic
                    </button>
                }
            </fieldset>
            {
                showDialog && <ListDialog title="Diagnostice "
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }
        </>
    );
}
